(() => {
  if (window.pizazzWishlistInitialized) return;
  window.pizazzWishlistInitialized = true;

  const STORAGE_KEY = "pizazz:wishlist:v1";
  const SELECTOR = "[data-pizazz-wishlist-toggle]";
  const ROOT = window.Shopify?.routes?.root || "/";
  const MAX_ITEMS = 100;
  let renderVersion = 0;

  function readWishlist() {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];

    const parsed = JSON.parse(raw);

    if (
      !Array.isArray(parsed) ||
      !parsed.every(
        handle =>
          typeof handle === "string" &&
          handle.length > 0 &&
          handle.length <= 255 &&
          !/[/?#\\]/.test(handle)
      )
    ) {
      throw new Error("Invalid wishlist data");
    }

    return [...new Set(parsed)];
  }

  function announce(message) {
    let status = document.getElementById("pizazz-wishlist-announcement");

    if (!status) {
      status = document.createElement("div");
      status.id = "pizazz-wishlist-announcement";
      status.className = "visually-hidden";
      status.setAttribute("role", "status");
      status.setAttribute("aria-live", "polite");
      document.body.append(status);
    }

    status.textContent = message;
  }
function updateWishlistCounts() {
  let count = 0;

  try {
    count = readWishlist().length;
  } catch {
    count = 0;
  }

  document.querySelectorAll('a[href]').forEach((link) => {
    const url = new URL(link.href, window.location.origin);

    if (
      url.origin !== window.location.origin ||
      !url.pathname.replace(/\/+$/, '').endsWith('/pages/wishlist')
    ) {
      return;
    }

    let badge = link.querySelector('[data-wishlist-count]');

    if (!badge) {
      badge = document.createElement('span');
      badge.setAttribute('data-wishlist-count', '');
      badge.setAttribute('aria-hidden', 'true');
      link.appendChild(badge);
    }

const isHeaderIcon = link.hasAttribute('data-wishlist-header-link');
const text = isHeaderIcon ? String(count) : ` (${count})`;

badge.hidden = isHeaderIcon && count === 0;
    if (badge.textContent !== text) {
      badge.textContent = text;
    }

    link.setAttribute(
      'aria-label',
      `Wishlist, ${count} ${count === 1 ? 'product' : 'products'}`
    );
  });
}
  function syncButtons() {
    let handles;

    try {
      handles = readWishlist();
    } catch {
      handles = [];
    }

    document.querySelectorAll(SELECTOR).forEach(button => {
      const saved = handles.includes(button.dataset.handle);
      const title = button.dataset.productTitle || "product";
      const label = saved
        ? `Remove ${title} from wishlist`
        : `Save ${title} to wishlist`;

      button.hidden = false;
      button.setAttribute("aria-pressed", String(saved));
      button.setAttribute("aria-label", label);

      const text = button.querySelector("[data-wishlist-button-text]");
      const nextText = saved ? "Saved" : "Save";

      if (text && text.textContent !== nextText) {
        text.textContent = nextText;
      }
     
    });
     updateWishlistCounts();
  }

  function element(tag, className, text) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }

  function productPath(handle) {
    return `${ROOT}products/${encodeURIComponent(handle)}`;
  }

  function makeCard(handle, product, errorMessage) {
    if (product?.card) {
  const card = product.card;

  // Keep a clearly labelled Remove action on the wishlist page.
  const remove = element(
    "button",
    "pizazz-wishlist-remove",
    "Remove"
  );

  const title = card.querySelector(".grid-product__title")
    ?.textContent.trim() || handle.replace(/-/g, " ");

  remove.type = "button";
  remove.dataset.pizazzWishlistToggle = "";
  remove.dataset.handle = handle;
  remove.dataset.productTitle = title;
  remove.setAttribute("aria-label", `Remove ${title} from wishlist`);
  remove.setAttribute("aria-pressed", "true");

  card.append(remove);
  return card;
}
    const card = element("article", "c-product");
    const title = product?.title || handle.replace(/-/g, " ");

    if (product) {
      const link = element("a");
      link.href = productPath(handle);

      if (product.featured_image) {
        const imageURL = new URL(
          product.featured_image,
          window.location.origin
        );

        if (imageURL.protocol === "https:") {
          imageURL.searchParams.set("width", "540");

          const image = element("img");
          image.src = imageURL.href;
          image.alt = "";
          image.loading = "lazy";
          image.width = 540;
          image.height = 810;
          link.append(image);
        }
      }

      link.append(element("h2", "c-product__title", title));
      card.append(link);

      if (!product.available) {
        card.append(element("p", "", "Currently sold out"));
      }

      const view = element("a", "pizazz-wishlist-view", "View product");
      view.href = productPath(handle);
      card.append(view);
    } else {
      card.append(element("h2", "c-product__title", title));
      card.append(element("p", "", errorMessage));

      const retry = element("button", "pizazz-wishlist-remove", "Retry");
      retry.type = "button";
      retry.addEventListener("click", () => renderWishlist());
      card.append(retry);
    }

    const remove = element(
      "button",
      "pizazz-wishlist-remove",
      "Remove"
    );

    remove.type = "button";
    remove.dataset.pizazzWishlistToggle = "";
    remove.dataset.handle = handle;
    remove.dataset.productTitle = title;
    remove.setAttribute("aria-label", `Remove ${title} from wishlist`);
    remove.setAttribute("aria-pressed", "true");

    card.append(remove);
    return card;
  }

async function loadProduct(handle) {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 12000);

  try {
    const url = new URL(productPath(handle), window.location.origin);
    url.searchParams.set("view", "wishlist-card");

    // Preserve an explicit duplicate-theme preview when present.
    const previewTheme = new URLSearchParams(window.location.search)
      .get("preview_theme_id");

    if (previewTheme) {
      url.searchParams.set("preview_theme_id", previewTheme);
    }

    const response = await fetch(url.href, {
      signal: controller.signal,
      credentials: "same-origin",
      headers: { Accept: "text/html" }
    });

    if (!response.ok) {
      return {
        error: response.status === 404
          ? "This product is no longer available at its saved address."
          : "Could not load this product. Please retry."
      };
    }

    const html = await response.text();
    const documentFragment = new DOMParser()
      .parseFromString(html, "text/html");

    const source = documentFragment.querySelector(
      "[data-wishlist-rendered-card]"
    );

    if (!source?.querySelector(".grid-product")) {
      return {
        error:
          "The wishlist card template could not be loaded. Check that it is saved in the theme you are previewing."
      };
    }

    // Import the card markup only, without executable scripts.
    source.querySelectorAll("script").forEach(script => script.remove());

    const card = document.importNode(source, true);
    card.classList.add("pizazz-wishlist-theme-card");

    // Inserted cards should not wait for collection entrance animations.
    card.querySelectorAll("[data-aos]").forEach(node => {
      node.removeAttribute("data-aos");
      node.classList.remove("aos-init", "aos-animate");
    });

    return { product: { card } };
  } catch {
    return {
      error: "Could not load this product. Please retry."
    };
  } finally {
    clearTimeout(timeout);
  }
}
  async function renderWishlist() {
    const grid = document.querySelector("[data-wishlist-grid]");
    const status = document.querySelector("[data-wishlist-status]");

    if (!grid || !status) return;

    const version = ++renderVersion;
    let handles;

    try {
      handles = readWishlist();
    } catch {
      grid.replaceChildren();
      grid.removeAttribute("aria-busy");
      status.textContent =
        "Your saved wishlist could not be read. Check your browser storage settings.";
      return;
    }

    grid.replaceChildren();

    if (!handles.length) {
      grid.removeAttribute("aria-busy");
      status.textContent = "Your wishlist is empty. Save a product to get started.";
      return;
    }

    status.textContent = "Loading your wishlist…";
    grid.setAttribute("aria-busy", "true");
    let failures = 0;

    // Load at most four products at once.
    for (let index = 0; index < handles.length; index += 4) {
      if (version !== renderVersion) return;

      const batch = handles.slice(index, index + 4);
      const results = await Promise.all(batch.map(loadProduct));

      if (version !== renderVersion || !grid.isConnected) return;

      results.forEach((result, batchIndex) => {
        if (!result.product) failures++;

        grid.append(
          makeCard(batch[batchIndex], result.product, result.error)
        );
      });
    }

    grid.removeAttribute("aria-busy");
    status.textContent =
      `${handles.length} saved product${handles.length === 1 ? "" : "s"}.` +
      (failures ? " Some products could not be loaded; you can retry them." : "");

    syncButtons();
  }

  document.addEventListener("click", event => {
    const button = event.target.closest(SELECTOR);
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    const handle = button.dataset.handle;
    if (!handle) return;

    try {
      const handles = readWishlist();
      const alreadySaved = handles.includes(handle);

      if (!alreadySaved && handles.length >= MAX_ITEMS) {
        window.alert("Your wishlist is full. Remove an item before saving another.");
        return;
      }

      const next = alreadySaved
        ? handles.filter(item => item !== handle)
        : [...handles, handle];

      localStorage.setItem(STORAGE_KEY, JSON.stringify(next));

      syncButtons();
      announce(alreadySaved ? "Removed from wishlist." : "Saved to wishlist.");

      if (button.closest("[data-wishlist-grid]")) {
        const heading = document.getElementById("wishlist-heading");
        if (heading) {
          heading.setAttribute("tabindex", "-1");
          heading.focus();
        }
      }

      renderWishlist();
    } catch {
      window.alert(
        "Your wishlist could not be saved. Check that browser storage is allowed."
      );
    }
  }, true);

  window.addEventListener("storage", event => {
    if (event.key === STORAGE_KEY || event.key === null) {
      syncButtons();
      renderWishlist();
    }
  });

  window.addEventListener("pageshow", () => {
    syncButtons();
    renderWishlist();
  });

  // Synchronize buttons added by collection filtering or quick-view sections.
  let syncPending = false;

  const observer = new MutationObserver(records => {
    const addedButton = records.some(record =>
      [...record.addedNodes].some(node =>
        node.nodeType === 1 &&
        (node.matches(SELECTOR) || node.querySelector(SELECTOR))
      )
    );

    if (!addedButton || syncPending) return;

    syncPending = true;
    requestAnimationFrame(() => {
      syncPending = false;
      syncButtons();
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
  syncButtons();
})();